<template>
  <div class="mobile-container">
    <VCard elevation="0" class="grey lighten-5 pa-0 pa-md-6 my-3 my-md-6 pb-4">
      <div class="step-title mb-0 mb-md-2">
        {{ category.title || category.name }}
      </div>
      <div class="step-subtitle">
        {{ category.subtitle || $t('popular') }}
      </div>
      <VacancyWizardSubCategories
        class="px-4 px-md-0"
        @select="select"
        v-if="category.children && category.children.length"
        :categories="category.children"
      />
      <template v-if="questions">
        <div class="px-4 px-md-0">
          <VacancySelectQuestionRow
            v-for="(item,index) in showedQuestions"
            :key="index"
            :question="item"
            :selected="selected"
            @selected="addQuestion"
            @unselected="removeQuestion"
          />
        </div>
      </template>
      <template v-else>
        <Preloader />
      </template>
      <div class="d-none d-md-block mt-6 pa-4 pt-0 pa-md-0" v-if="otherQuestions.length > 0">
        <a class="link-dotted" @click="showQuestions">
          {{ $t('showMore') }}
          {{ showNum }}
        </a>
      </div>
      <VCard
        v-if="otherQuestions.length > 0"
        tile
        class="show-more white text-center grey--text d-md-none pa-4 py-3 mt-2 mx-4"
        elevation="0"
        @click="showQuestions"
      >
        {{ $t('showMore') }}
        {{ showNum }}
      </VCard>
    </VCard>
  </div>
</template>

<script>
import InterviewVideoQuestionVideo from '@/orm/models/Interview/InterviewVideoQuestionVideo';
import VacancySelectQuestionRow from '@/components/Vacancy/VacancySelectQuestionRow';
import VacancyWizardSubCategories from '@/components/Vacancy/VacancyWizardSubCategories';
import Wizard from '@/orm/models/Wizard/Wizard';
import Preloader from '@/components/Preloader';

export default {
  name: 'VacancyWizardCategory',
  components: {
    Preloader,
    VacancyWizardSubCategories,
    VacancySelectQuestionRow,
  },
  props: {
    category: {
      type: Object,
      default: () => {
      },
    },
    selectedQuestions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show: false,
      questions: [],
      minimumNumQuestions: 10,
      showedQuestions: [],
    };
  },
  computed: {
    otherQuestions() {
      return this.questions.filter(
        (q) => !this.showedQuestions.some((question) => q.questionId === question.questionId),
      );
    },
    selected() {
      return Wizard.modelState().selectedQuestions;
    },
    showNum() {
      return this.otherQuestions.length > this.minimumNumQuestions
        ? this.minimumNumQuestions : this.otherQuestions.length;
    },
    allQuestions() {
      return InterviewVideoQuestionVideo.query()
        .withAllRecursive()
        .all();
    },
  },
  watch: {
    $route(to, from) {
      this.loadQuestions();
      this.hide();
    },
    allQuestions() {
      this.loadQuestions();
    },
  },
  created() {
    this.loadQuestions();
  },
  methods: {
    loadQuestions() {
      this.questions = this.category.questions.map((question) => {
        return this.allQuestions.find((q) => {
          return q.questionId === question.id;
        });
      });
      this.showMinimumQuestions();
    },
    showMinimumQuestions() {
      this.showedQuestions = this.questions.filter((question) => question.recommended
        || this.selected.some((qs) => qs.questionId === question.questionId));
      const delta = this.minimumNumQuestions - this.showedQuestions.length;
      if (delta > 0) {
        this.showQuestionsByNum(delta);
      }
    },
    addQuestion(question) {
      if (this.isQuestionSelected(question)) {
        return;
      }
      Wizard.setSelectedQuestions([...this.selected, question]);
    },
    showQuestions() {
      this.showQuestionsByNum(this.showNum);
    },
    showQuestionsByNum(showNum) {
      const questionsToShow = this.otherQuestions.slice(0, showNum);
      this.showedQuestions = this.showedQuestions.concat(questionsToShow);
    },
    hide() {
      this.show = false;
    },
    removeQuestion(question) {
      Wizard.setSelectedQuestions(
        this.selected.filter((q) => q.type !== question.type || q.id !== question.id),
      );
    },
    isQuestionSelected(question) {
      return this.selected.some((q) => q.type === question.type && q.id === question.id);
    },
    select(category) {
      this.hide();
      this.$emit('selectCategory', category);
    },
  },
  beforeRouteEnter() {
    this.hide();
  },
  beforeRouteUpdate() {
    this.hide();
  },
};
</script>

<style lang="scss" scoped>
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .mobile-container {
      width: calc(100% + 24px);
      margin-left: -12px;
    }
  }
</style>

<style lang="scss">
.show-more:focus:before {
  display: none
}
</style>

<i18n locale="en" lang="yaml">
  popular: Most popular questions on this topic
  showMore: Show more
  questions: question | questions
  show: Hide
</i18n>

<i18n locale="ru" lang="yaml">
  popular: Самые популярные вопросы в этой теме
  showMore: Показать еще
  questions: вопросов | вопрос | вопроса | вопросов
  hide: Скрыть
</i18n>
